import { useState, useMemo } from 'react'
import { useInfiniteQuery } from 'react-query'
import { useClient } from '@hooks/useClient'
import { SortByType, SortingType } from '@components/Table/interface'
import { WithWriterSectionProps, WriterSectionProps } from './interface'

export function withWriterSection(Component: React.FC<WriterSectionProps>) {
  function WithWriterSection({ searchParams }: WithWriterSectionProps) {
    const client = useClient()
    const [sortBy, setSortBy] = useState<SortByType>({
      key: '',
      order: SortingType.ASC,
    })

    const {
      data: donationByWriter,
      isFetchingNextPage,
      fetchNextPage,
      isLoading,
    } = useInfiniteQuery(
      ['character-donation-by-wirter', searchParams, sortBy],
      ({ pageParam = 1 }) =>
        client!.characterClient?.getCharacterDonationByWriter({
          ...searchParams,
          ...sortBy,
          page: pageParam,
          limitPerPage: 10,
        }),
      {
        getNextPageParam: lastPage => {
          if (lastPage && lastPage.data.length) return lastPage.page + 1

          return undefined
        },
      }
    )

    function handleFetchNextPage() {
      if (!isFetchingNextPage) fetchNextPage()
    }

    function handleSort({ key, order }: SortByType) {
      setSortBy(prev => ({ ...prev, key, order }))
    }

    const data = useMemo(
      () => donationByWriter?.pages?.flatMap(page => page.data) ?? [],
      [donationByWriter]
    )

    const componentProps = {
      data,
      handleSort,
      handleFetchNextPage,
      isLoading,
    }

    return <Component {...componentProps} />
  }

  return WithWriterSection
}
